/**
 * Theme Store.
 *
 * Manages dark mode state with localStorage persistence. Applies the
 * "dark" class to the <html> element for CSS variable overrides.
 */

import { create } from "zustand";

interface ThemeState {
  isDark: boolean;
  toggle: () => void;
  initialize: () => void;
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  isDark: false,

  toggle: () => {
    const next = !get().isDark;
    set({ isDark: next });
    applyTheme(next);
    localStorage.setItem("theme", next ? "dark" : "light");
  },

  initialize: () => {
    const stored = localStorage.getItem("theme");
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)",
    ).matches;
    const isDark = stored ? stored === "dark" : prefersDark;
    set({ isDark });
    applyTheme(isDark);

    // Remove the no-transitions class after initial theme is set.
    requestAnimationFrame(() => {
      document.body.classList.remove("no-transitions");
    });
  },
}));

function applyTheme(isDark: boolean) {
  if (isDark) {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
}
